import {createContext} from 'react';

const cartaContext = createContext();

export default cartaContext;